if (!customElements.get('mini-gallery')) {
  class MiniGallery extends HTMLElement {
    connectedCallback() {
      this.thumbs = this.querySelectorAll('[data-thumb-index]');
      this.sliderComponent = this.querySelector('slider-component');

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = parseInt(thumb.dataset.thumbIndex, 10);
          this.#setActiveThumb(index);
          this.sliderComponent?.slider?.moveToIdx(index);
        });
      });

      this.#observeSlider();
    }

    #observeSlider() {
      const check = () => {
        const slider = this.sliderComponent?.slider;
        if (!slider) return requestAnimationFrame(check);

        slider.on('animationEnded', (s) => {
          const idx = s.track.details.rel;
          this.#setActiveThumb(idx);
        });
      };
      check();
    }

    #setActiveThumb(activeIndex) {
      this.thumbs.forEach((thumb, i) => {
        if (i === activeIndex) {
          thumb.classList.replace('border-transparent', 'border-black');
        } else {
          thumb.classList.replace('border-black', 'border-transparent');
        }
      });
    }
  }
  customElements.define('mini-gallery', MiniGallery);
}
